import { cn } from '@/lib/utils'

/** Botón circular tipo "pill" del header público — menú/buscar/carrito/tema comparten el mismo lenguaje visual. */
export const ICON_BUTTON_CLASS = cn(
  'flex size-10 shrink-0 items-center justify-center rounded-full border border-border/60',
  'bg-card/70 text-foreground shadow-sm backdrop-blur-sm transition-all duration-200',
  'hover:-translate-y-0.5 hover:border-primary/30 hover:bg-accent hover:text-accent-foreground hover:shadow-md',
  'active:translate-y-0 active:scale-95',
  'focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50',
)
